import { UseLoadingReturn } from "@/hooks/use-loading";
import useRemove from "@/hooks/use-remove";
import skuService from "@/services/sku.service";
import { RemoveByIdProps } from "@/types/requests.types";

export type UseRemoveSKUReturn = {
  remove: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveSKU = (): UseRemoveSKUReturn => {
  const {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    remove: remove,
  } = useRemove({
    operation: (skuId) => skuService.delete(skuId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    remove,
  };
};

export default useRemoveSKU;
